<template>
  <v-data-table
    :headers="headers"
    :loading="loading"
    :items="reasons_cancellation"
    :search="search"
    sort-by="id"
    @dblclick:row="handleClickRow"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>MOTIVOS CANCELAMENTO REEMBOLSO</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Busca"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          dark
          to="/royalties/cadastro/motivo-cancelamento-reembolso/novo"
        >
          <v-icon>mdi-plus</v-icon>
          Novo
        </v-btn>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-toolbar color="red lighten-1" dark class="text-h5"
              >Atenção</v-toolbar
            >
            <v-card-title class="text-h6">
              Tem certeza que deseja Deletar?
            </v-card-title>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Fechar</v-btn
              >
              <v-btn color="red darken-1" dark @click="deleteItemConfirm">
                <v-icon dark>mdi-delete</v-icon>
                Deletar
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <alert
        :type="typeAlert"
        :visible="showAlert"
        :message="messageAlert"
        :clickClose="() => (showAlert = false)"
      ></alert>
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.actions="{ item }">
      <v-tooltip top color="blue darken-1">
        <!-- eslint-disable-next-line -->
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            class="mr-2"
            color="blue darken-1"
            @click="editItem(item)"
            v-bind="attrs"
            v-on="on"
          >
            mdi-pencil
          </v-icon>
        </template>
        <span>Editar</span>
      </v-tooltip>
      <v-tooltip top color="error">
        <!-- eslint-disable-next-line -->
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            color="red darken-1"
            @click="deleteItem(item)"
            v-bind="attrs"
            v-on="on"
          >
            mdi-delete
          </v-icon>
        </template>
        <span>Deletar</span>
      </v-tooltip>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize"> Recarregar </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { URL } from "@/api/config";
import Alert from "@/components/Alert";

export default {
  components: { Alert },
  data: () => ({
    dialogDelete: false,
    search: "",
    loading: false,
    headers: [
      {
        text: "ID",
        align: "right",
        value: "id",
        width: 80,
      },
      { text: "Descrição", value: "description", width: 200 },
      { text: "Data Cadastro", value: "created_at", width: 120 },
      { text: "Última Atualização", value: "updated_at", width: 120 },
      {
        text: "Ação",
        value: "actions",
        sortable: false,
        width: 100,
        align: "right",
      },
    ],
    reasons_cancellation: [],
    editedItem: {
      id: "",
      description: "",
    },
    defaultItem: {
      id: "",
      description: "",
    },
    showAlert: false,
    typeAlert: "success",
    messageAlert: "",
  }),

  computed: {},

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.loading = true;
      this.reasons_cancellation = [];
      try {
        let response = await fetch(`${URL}reason-cancellation-refund`);
        let res = await response.json();
        this.reasons_cancellation = res;
      } catch (error) {
        console.log(error);
        this.messageAlert =
          "Não foi possível carregar os Motivos de Cancelamento, tente novamente mais tarde";
        this.typeAlert = "error";
        this.showAlert = true;
      } finally {
        this.loading = false;
      }
    },
    editItem(item) {
      this.$router.push({
        name: "ReasonCancellationRefundEdit",
        params: { id: item.id },
      });
    },
    deleteItem(item) {
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      this.loading = true;
      this.reasons_cancellation = [];
      try {
        let res = await fetch(
          `${URL}reason-cancellation-refund/${this.editedItem.id}`,
          {
            method: "DELETE",
          }
        );
        if (res.ok) {
          this.messageAlert = "Motivo de Cancelamento Deletado com sucesso";
          this.typeAlert = "success";
          this.showAlert = true;

          this.loading = false;
          this.initialize();
        }
      } catch (error) {
        this.messageAlert =
          "Não foi possível Deletar os Motivos de Cancelamento, tente novamente mais tarde";
        this.typeAlert = "error";
        this.showAlert = true;
        this.loading = false;
        console.log(error);
      }
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },
    handleClickRow(event, item) {
      console.log(event);
      this.editItem(item.item);
    },
  },
};
</script>
